// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"curtain"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M21 3V21H16L17 8.8293L16.9456 8.80947C15.8089 8.38267 15 7.2858 15 6C15 7.65685 13.6569 9 12 9C10.3431 9 9 7.65685 9 6C9 7.2858 8.19109 8.38267 7.05439 8.80947L7 8.8293L8 21H3V3H21Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M21 6C21 7.65685 19.6569 9 18 9C17.6494 9 17.3128 8.93985 17 8.82929M21 6V21H16L17 8.82929M21 6V3H3V6M17 8.82929C15.8348 8.41746 15 7.30622 15 6C15 7.65685 13.6569 9 12 9C10.3431 9 9 7.65685 9 6C9 7.30622 8.16519 8.41746 7 8.82929M3 6C3 7.65685 4.34315 9 6 9C6.35064 9 6.68722 8.93985 7 8.82929M3 6V21H8L7 8.82929","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M9 3H3V21H21V3H15H9Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-curtain')
export default class CurtainIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'curtain',
    }
  }
}
